import type { SVGProps } from 'react'

const SvgSearchIcon = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg
      role='img'
      aria-label='Zoekbalk uitklappen'
      xmlns='http://www.w3.org/2000/svg'
      width='1.438rem'
      height='1.438rem'
      fill='#900054'
      viewBox='0 0 24 24'
      {...props}
    >
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M13.7619 15.176C12.3146 16.3183 10.4869 17 8.5 17C3.80558 17 0 13.1944 0 8.5C0 3.80558 3.80558 0 8.5 0C13.1944 0 17 3.80558 17 8.5C17 10.4868 16.3183 12.3145 15.1761 13.7618L23.3138 21.8995L21.8996 23.3137L13.7619 15.176ZM15 8.5C15 12.0899 12.0899 15 8.5 15C4.91015 15 2 12.0899 2 8.5C2 4.91015 4.91015 2 8.5 2C12.0899 2 15 4.91015 15 8.5Z'
        fill='#900054'
      />
    </svg>
  )
}
export default SvgSearchIcon
